
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold text-outdoor-700 mb-4">404</h1>
        <p className="text-2xl font-medium mb-6">Página no encontrada</p>
        <p className="text-lg text-gray-600 mb-8">
          Lo sentimos, la página que estás buscando no existe o ha sido removida.
        </p>
        <Button 
          onClick={() => navigate("/dashboard")}
          className="bg-outdoor-700 hover:bg-outdoor-800"
        >
          Volver al Dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
